import { Theme } from '../interfaces';

export const StyleSizesMixin = (theme: Theme) => {
  return {
    sizeXS: {
      '& button, & select, & input, & label, & textarea, & .tip-message': {
        fontSize: `${theme.sizing.fontXS}rem`,
      },
      '& label.choiceLabel div': {
        border: `${theme.sizing.borderXS}rem solid`,
        height: '0.4rem',
        width: '0.4rem',
        marginTop: '0.1rem',
      },
      '& span.choiceSpan': {
        fontSize: `${theme.sizing.fontXS}rem`,
        color: theme.palette.contentFontColor,
      },
    },
    sizeS: {
      '& button, & select, & input, & label, & textarea, & .tip-message': {
        fontSize: `${theme.sizing.fontS}rem`,
      },
      '& label.choiceLabel div': {
        border: `${theme.sizing.borderS}rem solid`,
        height: '0.6rem',
        width: '0.6rem',
        marginTop: '0.150rem',
      },
      '& span.choiceSpan': {
        fontSize: `${theme.sizing.fontXS}rem`,
        color: theme.palette.contentFontColor,
      },
    },
    sizeM: {
      '& button, & select, & input, & label, & textarea, & .tip-message': {
        fontSize: `${theme.sizing.fontM}rem`,
      },
      '& label.choiceLabel div': {
        border: `${theme.sizing.borderM}rem solid`,
        height: '0.8rem',
        width: '0.8rem',
        marginTop: '0.2rem',
      },
      '& span.choiceSpan': {
        fontSize: `${theme.sizing.fontS}rem`,
        color: theme.palette.contentFontColor,
      },
    },
    sizeL: {
      '& button, & select, & input, & label, & textarea, & .tip-message': {
        fontSize: `${theme.sizing.fontL}rem`,
      },
      '& label.choiceLabel div': {
        border: `${theme.sizing.borderL}rem solid`,
        height: '1rem',
        width: '1rem',
        marginTop: '0.4rem',
      },
      '& span.choiceSpan': {
        fontSize: `${theme.sizing.fontM}rem`,
        color: theme.palette.contentFontColor,
      },
    },
    sizeXL: {
      '& button, & select, & input, & label, & textarea, & .tip-message': {
        fontSize: `${theme.sizing.fontXL}rem`,
      },
      '& label.choiceLabel div': {
        border: `${theme.sizing.borderXL}rem solid`,
        height: '1.2rem',
        width: '1.2rem',
        marginTop: '0.125rem',
      },
      '& span.choiceSpan': {
        fontSize: `${theme.sizing.fontL}rem`,
        color: theme.palette.contentFontColor,
      },
    },
  };
};
